export default async function getChartScreenshotBase64(chart) {
	return new Promise((resolve, reject) => {
		if (!chart) return;

		// Get SVG from chart
		const svg = chart.getSVG({
			exporting: {
				sourceWidth: chart.chartWidth,
				sourceHeight: chart.chartHeight,
			},
		});

		// Create canvas + image
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		const img = new Image();

		// Important: allow CORS-safe rendering
		img.crossOrigin = "anonymous";

		// Convert SVG into a Blob
		const svgBlob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
		const url = URL.createObjectURL(svgBlob);

		img.onload = function () {
			canvas.width = img.width;
			canvas.height = img.height;
			ctx.drawImage(img, 0, 0);
			URL.revokeObjectURL(url);

			// Base64 string
			const base64 = canvas.toDataURL("image/png");
			resolve(base64);
		};

		img.onerror = function (err) {
			reject(err);
		};

		img.src = url;
	});
}
